import type { HighlightConfig } from './types';

import { escapeSelector, getConfig, unwrapElement } from './utils';

// ----------------------------------------------------------------------------

function remove(element: HTMLElement, config: HighlightConfig = {}): void {
    const defConfig = getConfig(config);
    const selector = `${defConfig.tag}.${escapeSelector(defConfig.className)}`;
    const listHighlight = element.querySelectorAll<HTMLElement>(selector);

    for (const elHighlight of listHighlight) {
        unwrapElement(elHighlight);
    }
}

// ----------------------------------------------------------------------------

export { remove };
